import { useTranslation } from "react-i18next";
import type { AuthUser } from "../../auth/auth";
import { RoomDock } from "../stage/RoomDock";

// Floating dock for a call that is running while the user is on another route.
// It knows nothing about routes: the host decides when to show it.
export function CallBar({
  roomName,
  hasPasscode,
  maxParticipants,
  user,
  onSignOut,
  onReturn,
}: {
  roomName: string;
  hasPasscode: boolean;
  maxParticipants?: number;
  user: AuthUser | null;
  onSignOut: () => void;
  onReturn: () => void;
}) {
  const { t } = useTranslation();
  return (
    <section
      aria-label={t("callBar.label")}
      className="pointer-events-none fixed inset-x-0 bottom-3 z-40 flex justify-center px-3"
    >
      <RoomDock
        className="pointer-events-auto"
        roomName={roomName || t("callBar.label")}
        hasPasscode={hasPasscode}
        maxParticipants={maxParticipants}
        user={user}
        onSignOut={onSignOut}
        onReturn={onReturn}
      />
    </section>
  );
}
